var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// @ts-nocheck
import React from 'react';
import { Timepicker } from '../components/Timepicker';
import ViewNavigation from '../components/ViewNavigation';
var DaysView = /** @class */ (function (_super) {
    __extends(DaysView, _super);
    function DaysView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._setDate = function (e) {
            _this.props.updateDate(e);
        };
        return _this;
    }
    DaysView.prototype.render = function () {
        return (_jsx("div", { className: "rdtDays", children: _jsxs("table", { children: [_jsxs("thead", { children: [this.renderNavigation(), this.renderDayHeaders()] }), _jsx("tbody", { children: this.renderDays() }), this.renderFooter()] }) }));
    };
    DaysView.prototype.renderNavigation = function () {
        var _this = this;
        var date = this.props.viewDate;
        var locale = date.localeData();
        var label = this.props.label;
        return (_jsx(ViewNavigation, { onClickPrev: function () { return _this.props.navigate(-1, 'months'); }, onClickSwitch: function () { return _this.props.showView('months'); }, onClickNext: function () { return _this.props.navigate(1, 'months'); }, switchContent: locale.months(date, 'DD[]MMMM') + ' ' + date.year(), switchColSpan: 3, label: label, switchProps: { 'data-value': this.props.viewDate.month() } }));
    };
    DaysView.prototype.renderDayHeaders = function () {
        var locale = this.props.viewDate.localeData();
        var dayItems = getDaysOfWeek(locale).map(function (day, index) { return (_jsx("th", { className: "dow", children: day }, day + index)); });
        return _jsx("tr", { children: dayItems });
    };
    DaysView.prototype.renderDays = function () {
        var date = this.props.viewDate;
        var startOfMonth = date.clone().startOf('month');
        var endOfMonth = date.clone().endOf('month');
        // We need 42 days in 6 rows
        // starting in the last week of the previous month
        var rows = [[], [], [], [], [], []];
        var startDate = date.clone().subtract(1, 'months');
        startDate.date(startDate.daysInMonth()).startOf('week');
        var endDate = startDate.clone().add(42, 'd');
        var i = 0;
        while (startDate.isBefore(endDate)) {
            var row = getRow(rows, i++);
            row.push(this.renderDay(startDate, startOfMonth, endOfMonth));
            startDate.add(1, 'd');
        }
        return rows.map(function (r, i) { return _jsx("tr", { children: r }, "".concat(endDate.month(), "_").concat(i)); });
    };
    DaysView.prototype.renderDay = function (date, startOfMonth, endOfMonth) {
        var selectedDate = this.props.selectedDate;
        var secondValue = this.props.secondValue;
        var dayProps = {
            key: date.format('M_D'),
            'data-value': date.date(),
            'data-month': date.month(),
            'data-year': date.year(),
        };
        var className = 'rdtDay';
        if (date.isBefore(startOfMonth)) {
            className += ' rdtOld';
        }
        else if (date.isAfter(endOfMonth)) {
            className += ' rdtNew';
        }
        if (secondValue && date.isBefore(secondValue) && date.isAfter(selectedDate)) {
            className += ' rdtActiveRange';
        }
        if (secondValue && date.isAfter(secondValue) && date.isBefore(selectedDate)) {
            className += ' rdtActiveRange';
        }
        if (selectedDate && date.isSame(selectedDate, 'day')) {
            className += ' rdtActive';
        }
        if (secondValue && date.isSame(secondValue, 'day')) {
            className += ' rdtActiveSecond';
        }
        if (date.isSame(this.props.moment(), 'day')) {
            className += ' rdtToday';
        }
        if (this.props.isValidDate(date)) {
            dayProps.onClick = this._setDate;
        }
        else {
            className += ' rdtDisabled';
        }
        dayProps.className = className;
        return this.props.renderDay(dayProps, date.clone(), selectedDate && selectedDate.clone());
    };
    DaysView.prototype.renderFooter = function () {
        if (!this.props.timeFormat)
            return;
        var setTime = this.props.setTime;
        var value = this.props.value;
        var disabled = this.props.disabled;
        return (_jsx("tfoot", { children: _jsx("tr", { children: _jsx(Timepicker, { setTime: setTime, value: value, disabled: disabled }) }) }));
    };
    DaysView.defaultProps = {
        isValidDate: function () { return true; },
        renderDay: function (props, date) { return _jsx("td", __assign({}, props, { children: date.date() })); },
    };
    return DaysView;
}(React.Component));
export default DaysView;
function getRow(rows, day) {
    return rows[Math.floor(day / 7)];
}
/**
 * Get a list of the days of the week
 * depending on the current locale
 * @return {array} A list with the shortname of the days
 */
function getDaysOfWeek(locale) {
    var first = locale.firstDayOfWeek();
    var dow = [];
    var i = 0;
    locale._weekdaysMin.forEach(function (day) {
        dow[(7 + i++ - first) % 7] = day;
    });
    return dow;
}
